import { mount } from '../dom-lifecycle';

mount('.needs-validation', form => {
	$(form).on('submit', function (event) {
		$(this).addClass('was-validated');
		if (!this.checkValidity()) {
			event.preventDefault();
			event.stopImmediatePropagation();
			$(this).trigger('submit-invalid');
			scrollToFirstError(this);
		}
	}).on('reset', function () {
		$(this).removeClass('was-validated');
	});
});

$.fn.toggleValid = function (valid) {
	this.each((i, element) => element.setCustomValidity(valid ? "" : 'invalid'));
};
$.fn.toggleRuleValid = function (ruleName, valid) {
	this.each((i, element) => setCustomRuleValidity(element, ruleName, valid));
};
$.fn.addRuleValidator = function (rule, callback) {
	this.each(function () {
		let update = () => $(this).toggleRuleValid(rule, callback(this));
		$(this).on('input change', update);
		update();
	});
};

export function mountRuleValidator(selector, rule, callback) {
	mount(selector, el => $(el).addRuleValidator(rule, callback));
}

export function scrollToFirstError(form) {
	const firstError = $(form).find('.invalid-feedback:visible:first')[0];
	firstError?.scrollIntoView({ behavior: "smooth", block: 'center' });
}

export function setCustomRuleValidity(field, ruleName, errorMessageOrBoolean)
{
	if (errorMessageOrBoolean === false) {
		errorMessageOrBoolean = 'invalid';
	} else if (errorMessageOrBoolean === true) {
		errorMessageOrBoolean = '';
	}
	field._customValidity ??= new Map();
	if (errorMessageOrBoolean === '') {
		field._customValidity.delete(ruleName);
	} else {
		field._customValidity.set(ruleName, errorMessageOrBoolean);
	}
	field.setCustomValidity(field._customValidity.values().next().value ?? '');
};